import { baseScopesRequiredPerField, type FieldScopes } from '../../../common/fields-scopes';

export const commonIssueTransitionGranularScopes = ['read:issue.transition:jira'];

export const baseIssueTransitionScopesRequiredPerField: FieldScopes = {
	coarse: baseScopesRequiredPerField.coarse,
	granular: [...baseScopesRequiredPerField.granular, ...commonIssueTransitionGranularScopes],
};
